var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "Section",
        [
          _c("SectionHeader", {
            attrs: {
              title: _vm.$t("apps.payroll.message.date"),
              subtitle: _vm.$t("series.prl") + " " + _vm.prlCode
            }
          }),
          _vm._v(" "),
          _c(
            "FormRow",
            [
              _c(
                "Col",
                { attrs: { className: "col-lg-2" } },
                [
                  _c("Label", {
                    attrs: {
                      text: _vm.$t("apps.payroll.label.datestart") + " *"
                    }
                  }),
                  _vm._v(" "),
                  _c("BaseInputDatePicker", {
                    attrs: {
                      classNames: [
                        { "is-invalid": _vm.$v.input.dateStart.$error }
                      ],
                      disabled: _vm.disabled
                    },
                    model: {
                      value: _vm.$v.input.dateStart.$model,
                      callback: function($$v) {
                        _vm.$set(_vm.$v.input.dateStart, "$model", $$v)
                      },
                      expression: "$v.input.dateStart.$model"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "Col",
                { attrs: { className: "col-lg-2" } },
                [
                  _c("Label", {
                    attrs: { text: _vm.$t("apps.payroll.label.dateend") + " *" }
                  }),
                  _vm._v(" "),
                  _c("BaseInputDatePicker", {
                    attrs: {
                      classNames: [
                        { "is-invalid": _vm.$v.input.dateEnd.$error }
                      ],
                      disabled: _vm.disabled
                    },
                    model: {
                      value: _vm.$v.input.dateEnd.$model,
                      callback: function($$v) {
                        _vm.$set(_vm.$v.input.dateEnd, "$model", $$v)
                      },
                      expression: "$v.input.dateEnd.$model"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.input.dateEnd && _vm.input.dateEnd
                ? _c(
                    "Col",
                    { attrs: { className: "col-lg-1" } },
                    [
                      _c("Label", { attrs: { text: "&nbsp;" } }),
                      _vm._v(" "),
                      _c("BaseInput", {
                        attrs: {
                          value: _vm.$t("apps.payroll.message.daterange", {
                            number: _vm.diffDays
                          }),
                          disabled: true
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.isCreatePage
        ? _c(
            "Section",
            [
              _c("SectionHeader", {
                attrs: { title: _vm.$t("apps.payroll.message.group") }
              }),
              _vm._v(" "),
              _c(
                "FormRow",
                [
                  !_vm.groups.length
                    ? _c(
                        "Col",
                        { attrs: { className: "col-lg-12" } },
                        [
                          _c("Label", {
                            attrs: {
                              text: _vm.$t("apps.payroll.label.employeegroup")
                            }
                          }),
                          _vm._v(" "),
                          _c("BaseNotFoundData", {
                            attrs: {
                              title: _vm.$t(
                                "apps.payroll.message.notfoundgroups"
                              ),
                              detail: _vm.$t(
                                "apps.payroll.message.createnewgroup"
                              )
                            }
                          })
                        ],
                        1
                      )
                    : _c(
                        "Col",
                        { attrs: { className: "col-lg-4" } },
                        [
                          _c("Label", {
                            attrs: {
                              text: _vm.$t("apps.payroll.label.employeegroup")
                            }
                          }),
                          _vm._v(" "),
                          _c("BaseDropdown", {
                            attrs: {
                              options: _vm.groupOptions,
                              disabled: _vm.disabled
                            },
                            on: { change: _vm.handleChangeGroup },
                            model: {
                              value: _vm.input.groupId,
                              callback: function($$v) {
                                _vm.$set(_vm.input, "groupId", $$v)
                              },
                              expression: "input.groupId"
                            }
                          })
                        ],
                        1
                      )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isCreatePage
        ? _c(
            "Section",
            [
              _c("SectionHeader", {
                attrs: { title: _vm.$t("apps.payroll.message.condition") }
              }),
              _vm._v(" "),
              _c(
                "FormRow",
                [
                  !_vm.conditions.length
                    ? _c(
                        "Col",
                        { attrs: { className: "col-lg-12" } },
                        [
                          _c("BaseNotFoundData", {
                            attrs: {
                              title: _vm.$t(
                                "apps.payroll.message.notfoundconditions"
                              ),
                              detail: _vm.$t(
                                "apps.payroll.message.createnewcondition"
                              )
                            }
                          })
                        ],
                        1
                      )
                    : _c("Col", { attrs: { className: "col-lg-12" } }, [
                        _c(
                          "div",
                          { staticClass: "row" },
                          _vm._l(_vm.conditions, function(item, index) {
                            return !item.deletedAt
                              ? _c(
                                  "div",
                                  { key: index, staticClass: "col-2 mb-3" },
                                  [
                                    _c("BaseCheckbox", {
                                      attrs: {
                                        label: item.name,
                                        val: item.conditionId,
                                        disabled: _vm.disabled
                                      },
                                      model: {
                                        value: _vm.input.conditionIds,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.input,
                                            "conditionIds",
                                            $$v
                                          )
                                        },
                                        expression: "input.conditionIds"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          }),
                          0
                        )
                      ])
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "Section",
        [
          _c("SectionHeader", {
            attrs: { title: _vm.$t("apps.payroll.message.employeelist") }
          }),
          _vm._v(" "),
          _c(
            "FormRow",
            [
              !_vm.filterEmployees.length
                ? _c(
                    "Col",
                    { attrs: { className: "col-lg-12" } },
                    [
                      _c("BaseNotFoundData", {
                        attrs: {
                          title: _vm.$t(
                            "apps.payroll.message.notfoundemployeee"
                          ),
                          detail: _vm.$t(
                            "apps.payroll.message.createnewemployee"
                          )
                        }
                      })
                    ],
                    1
                  )
                : _c(
                    "Col",
                    { attrs: { className: "col-lg-12" } },
                    [
                      _vm.isRender
                        ? _c("BasePaySlipEmployee", {
                            attrs: {
                              conditionIds: _vm.input.conditionIds,
                              conditions: _vm.conditions,
                              employees: _vm.filterEmployees,
                              disabled: _vm.disabled
                            },
                            model: {
                              value: _vm.input.employees,
                              callback: function($$v) {
                                _vm.$set(_vm.input, "employees", $$v)
                              },
                              expression: "input.employees"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "Section",
        [
          _c(
            "FormRow",
            [
              _c(
                "Col",
                { attrs: { className: "col-lg-6" } },
                [
                  _c("BaseTextArea", {
                    attrs: {
                      placeholder: _vm.$t("placeholder.note"),
                      disabled: _vm.disabled,
                      rows: 3
                    },
                    model: {
                      value: _vm.input.note,
                      callback: function($$v) {
                        _vm.$set(_vm.input, "note", $$v)
                      },
                      expression: "input.note"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("Col", { attrs: { className: "col-lg-4 ml-auto" } }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-6" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t("apps.payroll.message.employeelistcount")
                        ) +
                        "\n        "
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-6 text-right" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.selectedEmployeeCount) +
                        "\n        "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row mt-2" }, [
                  _c("div", { staticClass: "col-6" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("apps.payroll.message.grandtotal")) +
                        "\n        "
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-6 text-right" }, [
                    _c("span", { staticClass: "text-underline-border" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.getNumber(_vm.grandTotal)) +
                          "\n          "
                      )
                    ])
                  ])
                ])
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.edit && _vm.showActionButtons
        ? _c("BaseFormAction", {
            attrs: {
              textCancel: _vm.$t("button.cancel"),
              textSubmit: _vm.$t("button.save"),
              isSubmitted: _vm.isSubmitted
            },
            on: { onCancel: _vm.handleCancel, onSubmit: _vm.handleSubmit }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f95ab3f2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f95ab3f2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/combine/PayrollPaySlipForm.vue
// module id = null
// module chunks = 